import merchantApiFactory from '../../modules/merchant/merchantApi';

import {generateDefaultAsyncSaga, generateDefaultAsyncWatcher} from '../core/reduxUtils';
import {
  getMerchantInfoActionCreators,
  getMerchantInfoByNameActionCreators, getMerchantInfoByPostfixActionCreators,
  getMerchantSearchActionCreators,
  getStaticPageActionCreators, getSuperTabDataActionCreators
} from '../actions/merchantActions';
import staticPageApiFactory from '../../modules/static/staticPageApi';

function merchantPageSagasFactory({storefrontApiClient}) {
  const merchantApi = merchantApiFactory(storefrontApiClient);
  const staticPageApi = staticPageApiFactory(storefrontApiClient);

  const getMerchantInfoSaga = generateDefaultAsyncSaga(
    merchantApi.getMerchantInfo,
    getMerchantInfoActionCreators,
    payload => [payload.params]
  )
  const getMerchantInfoByNameSaga = generateDefaultAsyncSaga(
    merchantApi.getMerchantInfoByName,
    getMerchantInfoByNameActionCreators,
    payload => [payload.params]
  )
  const getMerchantInfoByPostfixSaga = generateDefaultAsyncSaga(
    merchantApi.getMerchantInfoByPostfix,
    getMerchantInfoByPostfixActionCreators,
    payload => [payload.params]
  )

  const getMerchantSearchSaga = generateDefaultAsyncSaga(
    merchantApi.getMerchantSearch,
    getMerchantSearchActionCreators,
    payload => [payload.params]
  )
  const getSuperTabDataSaga = generateDefaultAsyncSaga(
    merchantApi.getSuperTabData,
    getSuperTabDataActionCreators,
    payload => [payload.params]
  )
  const getStaticPageInfoSaga = generateDefaultAsyncSaga(
    staticPageApi.getStaticPage,
    getStaticPageActionCreators,
    payload => [
      payload.staticPageId,
      payload.staticPageKey,
      payload.params,
    ],
  )
  const watchGetMerchantInfo = generateDefaultAsyncWatcher(
    'GET_MERCHANT_INFO',
    getMerchantInfoSaga
  );

  const watchGetMerchantInfoByName = generateDefaultAsyncWatcher(
    'GET_MERCHANT_INFO_BY_NAME',
    getMerchantInfoByNameSaga
  )

  const watchGetMerchantInfoByPostfix = generateDefaultAsyncWatcher(
    'GET_MERCHANT_INFO_BY_POSTFIX',
    getMerchantInfoByPostfixSaga
  )

  const watchGetMerchantSearch = generateDefaultAsyncWatcher(
    'GET_MERCHANT_SEARCH',
    getMerchantSearchSaga
  )
  const watchGetSuperTabData = generateDefaultAsyncWatcher(
    'GET_SUPER_TAB_DATA',
    getSuperTabDataSaga
  )

  const watchGetStaticPageInfo = generateDefaultAsyncWatcher(
    'GET_STATIC_PAGE_INFO',
    getStaticPageInfoSaga
  )

  return [
    watchGetMerchantInfo(),
    watchGetMerchantInfoByName(),
    watchGetMerchantInfoByPostfix(),
    watchGetMerchantSearch(),
    watchGetSuperTabData(),
    watchGetStaticPageInfo()
  ]
}

export default merchantPageSagasFactory
